
import React from 'react'
import Navbar from '../../components/modules/Navbar'
import {BsFileArrowDown} from 'react-icons/bs'
import { Link as LinkScroll} from 'react-scroll';
import './AssoPartStyles.css'
import { useEffect, useRef } from 'react';
import { isMobile,BrowserView} from 'react-device-detect';
import ScrollTrigger from 'gsap/ScrollTrigger'
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { useTranslation} from "react-i18next";

//import images

import pics from '../../assets/asso_partenaire/pics.png'
import adr from '../../assets/asso_partenaire/adr.png'
import hyris from '../../assets/asso_partenaire/hyris.png'
import capese from '../../assets/asso_partenaire/çapèse.png'
import sbcs from '../../assets/asso_partenaire/sbcs.png'
import impact from '../../assets/asso_partenaire/impact.png'
import pascal from '../../assets/asso_partenaire/assopascal.png'
import Footer from '../../components/modules/Footer';

gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

const AssoPart = () => {
  const { t } = useTranslation('common');

  const FadeUpScroll = (elem)=>{
    gsap.fromTo(
        elem,
        
        {
          y:20,
          opacity:0
        },
        {
           y:0, 
           opacity:1,
            duration:1,
            scrollTrigger:{
                trigger:elem,
                start:"top center",
                end:"bottom center",
          
                toggleActions:"play none pause none",
                
                
                
            }
           
            
        }
       
    )
    
}
  useEffect(() =>{
    FadeUpScroll('#pics')
    FadeUpScroll('#hyris')
    FadeUpScroll('#adr')
    FadeUpScroll('#sbcs')
    FadeUpScroll('#impact')
    FadeUpScroll('#capese')
  },[])
    useEffect(() =>{
        let path = document.querySelector('.path')
        let mesure = isMobile? '3400' : '2800'
        let longueur = isMobile ? '2400' : '2700'

       
        window.addEventListener('scroll', () =>{
              var scrollPourcentage = (document.documentElement.scrollTop + document.body.scrollTop)/(document.documentElement.scrollHeight - document.documentElement.clientHeight);
              var drawLenght = mesure * scrollPourcentage - 200
              path.style.strokeDashoffset = longueur - drawLenght
        })
      

    },[])
    const titleRef = useRef();
    const onLoad = () =>{
      gsap.timeline().fromTo(".letter",
      {
          x: -100,
          opacity:0,
      },
      {
          x:0,
          opacity:1,
          stagger:0.33,
          delay:0.3,
      }).to('.letter',
      {
          margin: "0 1vw",
          delay:0.8,
          duration:0.5
      }).to(".letter",{
          margin: "0",
          delay:0.8,
          duration:0.5
      })
      
  }
  
  
  useEffect(()=>{
    onLoad();
  
        },[])
  

    return (
        <div>
           <Navbar  scroll='false' color='transparent' />
           <div className='asso-part'>
            <div className='asso-part-home'>
              <div className='asso-part-title'>
                <h1 id='title' ref={titleRef}>
                <span className='letter'>{t('assoPart.title1')}</span>
                <span className='letter'> </span>
                <span className='letter'>{t('assoPart.title2')}</span>
                <span className='letter'> </span>
                <span className='letter'>{t('assoPart.title3')}</span>
                  
                  </h1>

              </div>               
              <LinkScroll to='asso-part-content' smooth={true}  offset={-10} duration={1000}> <BsFileArrowDown style={{color:'white'}} className='fleche-mazars'/></LinkScroll>
              <div className='vague'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,288L60,288C120,288,240,288,360,266.7C480,245,600,203,720,208C840,213,960,267,1080,288C1200,309,1320,299,1380,293.3L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
                    </div>

            </div>
             
           </div>
           <div className='asso-part-content'>
                <div className='line-container'>
                    <svg width="264" height="2381" viewBox="0 0 264 2381" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className='path' d="M1.5 0.5V240.5C1.5 297.167 17.2 429.8 80 507C142.8 584.2 106.167 678.833 80 716.5C48.3333 752 -3.2 836 44 888C91.2 940 145.333 1003.33 166.5 1028.5C195.5 1068.83 234.2 1160.9 157 1206.5C60.5 1263.5 44 1414 44 1474.5C44 1534.83 58.4 1666 116 1708C188 1760.5 308.5 1844 245 1992.5C181.5 2141 132 2261 124 2380" stroke="black" strokeWidth="2"/>
                    </svg>
                </div>
                <div className='asso-part-inner'>
                    <div id='pics'>
                        <div >
                              <img  src={pics} alt="" />
                        </div>
                      <div className='asso-part-inner-content'>
                               <BrowserView className='asso-part-inner-titles'><h2> Pics</h2></BrowserView>  
                        <p> {t('assoPart.pics')}</p>
<a href='https://galerie.pics/' className='btn-asso'> {t('assoPart.btn')}</a>
                      </div>
               
                    </div>
                    <div id='hyris'>
                        <div>
                              <img  src={hyris} alt="" />
                        </div>
                      <div className='asso-part-inner-content'>
                      <BrowserView className='asso-part-inner-titles'> <h2> Hyris</h2></BrowserView>
                        <p> {t('assoPart.hyris')}</p>
<a href='https://hyris.tv/' className='btn-asso'> {t('assoPart.btn')}</a>
                      </div>
               
                    </div>
                    <div id='adr'>
                        <div>
                              <img  src={adr} alt="" />
                        </div>
                      <div className='asso-part-inner-content'>
                      <BrowserView className='asso-part-inner-titles'>  <h2> Association des Résidents</h2></BrowserView>
                        <p> {t('assoPart.adr')}</p>
<a href='https://adr.cs-campus.fr/' className='btn-asso'> {t('assoPart.btn')}</a>
                      </div>
               
                    </div>
                    <div id='sbcs'>
                        <div>
                              <img  src={sbcs} alt="" />
                        </div>
                      <div className='asso-part-inner-content'>
                      <BrowserView className='asso-part-inner-titles'>   <h2> SBCS</h2></BrowserView>
                        <p>{t('assoPart.sbcs')}</p>
<a href='https://www.sbcs-events.fr/' className='btn-asso'> {t('assoPart.btn')}</a>
                      </div>
               
                    </div>
                    <div id='pascal'>
                        <div>
                              <img  style={{height:'200px',width:'auto', marginRight:'75px', marginBottom:'200px'}} src={pascal} alt="" />
                        </div>
                      <div className='asso-part-inner-content'>
                      <BrowserView className='asso-part-inner-titles'>   <h2> PASCAL</h2></BrowserView>
                        <p>{t('assoPart.pascal')}</p>
<a href='https://www.instagram.com/asso_pascal/' className='btn-asso'> {t('assoPart.btnp')}</a>
                      </div>
               
                    </div>
                    <div id='impact'>
                        <div>
                              <img  src={impact} alt="" />
                        </div>
                      <div className='asso-part-inner-content'>
                      <BrowserView className='asso-part-inner-titles'>  <h2> Impact</h2></BrowserView>
                        <p> {t('assoPart.impact')}</p>
<button type='button' className='btn-asso'> {t('assoPart.btn')}</button>
                      </div>
               
                    </div>
                    <div id='capese'>
                        <div>
                              <img  src={capese} alt="" />
                        </div>
                      <div className='asso-part-inner-content'>
                      <BrowserView className='asso-part-inner-titles'>   <h2> Çapèse</h2></BrowserView>
                        <p> {t('assoPart.capese')}</p>
<a href='https://capese.cs-campus.fr/' className='btn-asso'> {t('assoPart.btn')}</a>
                      </div>
                      
               
                    </div>
                   




                    </div>
                    
        
           


           </div>
            <Footer/>
        </div>
    )
}

export default AssoPart